import Image from "next/image";
import Layout from "@/components/layout";
import styles from "@/styles/ServicesDetail.module.css";
import { useRouter } from "next/router";
import { Container, Row, Col, Accordion, Button } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";
import Link from "next/link";

const ThetaDetail = () => {
  const router = useRouter();
  const [next, setNext] = useState(false);
  const [showSideButton, setShowSideButton] = useState(false);
  const firstSectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!firstSectionRef.current) return;

      const sectionTop = firstSectionRef.current.getBoundingClientRect().bottom;

      setShowSideButton(sectionTop < 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <section
        className={`${styles["section-banner"]} "banner-page"`}
        style={{ background: "url(/images/theta-healing-banner.png)" }}
        ref={firstSectionRef}
      >
        <Container>
          <Row>
            <Col md={8} className="m-auto">
              <div className={styles["inner-content"]}>
                <h1 className={styles["banner-title"]}>
                  Welcome to our theta Healing Service!
                </h1>
                <p>
                  At Zenkify, we Believe in Transformation. Welcome to Our Theta
                  Healing Service at Our Energy Platform. Experience profound
                  change as we tap into the subconscious and the theta state to
                  release limitations, relieve stress, and nurture personal
                  growth. Unlock your true potential with us.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section
        className={styles["content-grid"] + " " + styles["section-content"]}
      >
        <Container>
          <Row>
            <Col
              lg={7}
              className="me-auto align-self-center order-lg-1 order-2"
            >
              <div className={styles["inner-content"]}>
                <h2>About Theta Healing</h2>
                <p>
                  Theta Healing is a holistic healing technique that combines
                  aspects of meditation, energy healing, and belief work. It was
                  developed by Vianna Stibal in the 1990s and is based on the
                  premise that our beliefs and thoughts have a profound impact
                  on our physical, emotional, and spiritual well-being. Theta
                  Healing derives its name from the theta brainwave state, which
                  is associated with deep relaxation and heightened intuition.
                  During a Theta Healing session, the practitioner and recipient
                  enter a meditative state where the brainwave activity slows
                  down to the theta frequency. This relaxed state allows access
                  to the subconscious mind, where deep-seated beliefs and
                  patterns can be explored and transformed.
                </p>
              </div>
            </Col>
            <Col lg={4} className="order-lg-2 order-1 align-self-center">
              <div className={styles["image"]}>
                <Image
                  width={400}
                  height={344}
                  src="/images/about-theta-healing.png"
                  alt="About Theta Healing"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section
        className={`${styles["content-grid"]} ${styles["working-section"]}`}
      >
        <Image
          width={150}
          height={101}
          src="/images/flower-shap-3.svg"
          className={styles["flower-top"]}
          alt="flower-shap"
        />
        <Image
          width={100}
          height={101}
          src="/images/flower-2.svg"
          className={styles["flower-right"]}
          alt="flower-shap"
        />
        <Container>
          <Row>
            <Col lg={4}>
              <Image
                width={420}
                height={420}
                src="/images/healing-working.png"
                className={styles["reikiwork-image"]}
                alt="Reiki Healing Service"
              />
            </Col>
            <Col lg={8} className="ms-auto align-self-center ps-md-5">
              <div className={styles["inner-content"] + " " + "pe-0"}>
                <h3>How Does Theta Healing Work</h3>
                <p>
                  Theta Healing operates through inducing a meditative theta
                  state, allowing access to the subconscious. It involves
                  identifying and transforming negative beliefs via muscle
                  testing, replacing them with positive ones. Practitioners
                  channel healing energy and gain intuitive insights to address
                  imbalances. This approach also emphasizes a quantum
                  connection, enabling individuals to co-create healing and
                  enhance their manifestation abilities for positive life
                  changes.
                </p>
                <ul>
                  <li>Theta Brainwave State Access</li>
                  <li>Energetic Healing and Intuition</li>
                  <li>Belief Restructuring</li>
                  <li>Quantum Connection and Manifestation</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
        <Image
          width={79}
          height={130}
          src="/images/flower-shap-2.svg"
          className={styles["flower-bottom"]}
          alt="flower-shap"
        />
      </section>
      <section
        className={styles["benefits-service"] + " " + styles["benefits-theta"]}
      >
        <Container>
          <Row>
            <Col lg={8} className="m-auto pb-4">
              <div className="section-title">
                <h3 className="title">Benefits of Theta Healing</h3>
                <p>
                  Theta Healing provides stress relief, emotional healing, and
                  self-empowerment. Through the theta brainwave state, it
                  tackles ingrained beliefs, aids physical well-being,
                  encourages spiritual growth, and amplifies goal achievement.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Stress Reduction</h4>
                <p>
                  Theta Healing induces deep relaxation, alleviating stress and
                  promoting inner calm by engaging the theta brainwave state.
                </p>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Emotional Healing</h4>
                <p>
                  By addressing buried emotional traumas and negative beliefs,
                  Theta Healing helps individuals find emotional relief and
                  healing.
                </p>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Empowerment</h4>
                <p>
                  {" "}
                  It enables the transformation of limiting beliefs into
                  empowering thoughts, fostering self-confidence and personal
                  development.
                </p>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Physical Wellness</h4>
                <p>
                  While not a substitute for medical care, Theta Healing
                  complements it by addressing emotional factors contributing to
                  physical issues.
                </p>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Spiritual Growth</h4>
                <p>
                  Theta Healing aids in spiritual exploration, facilitating
                  connections with higher aspects of oneself and a deeper
                  understanding of purpose.
                </p>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-4">
              <div className={styles["card-benefits"]}>
                <h4>Manifestation</h4>
                <p>
                  Through clearing negativity and focusing intentions, Theta
                  Healing supports the realization of personal goals and
                  intentions effectively.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
        <Image
          width={100}
          height={128}
          src="/images/stone-icon.svg"
          className={styles["stone-image"]}
          alt="flower"
        />
      </section>
      <section className={styles["service-section"]}>
        <Container>
          <Row>
            <Col md={4} className="mb-md-0 mb-2">
              <div className={styles["service-image"]}>
                <Image
                  width={420}
                  height={325}
                  src="/images/theta-healing-1.png"
                  alt="renki healing"
                />
              </div>
            </Col>
            <Col md={4} className="mb-md-0 mb-2">
              <div className={styles["service-image"]}>
                <Image
                  width={420}
                  height={325}
                  src="/images/theta-healing-2.png"
                  alt="renki healing"
                />
              </div>
            </Col>
            <Col md={4}>
              <div className={styles["service-image"]}>
                <Image
                  width={420}
                  height={325}
                  src="/images/theta-healing-3.png"
                  alt="renki healing"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="faq-section">
        <Container>
          <Row>
            <Col lg={10} className="m-auto">
              <div className="section-title">
                <h3 className="title">FAQ’s</h3>
                <p>
                  Get Answers to your Questions.Learn and Discover Energy
                  Healing Benefits, Sessions, Techniques, and more. Clear your
                  Doubts and make an Informed Choice. Explore Energy Healing
                  with our FAQs.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={10} className="m-auto">
              <Accordion
                defaultActiveKey="0"
                className="faq-accordion"
                id="accordionExample"
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <span>
                      What is Theta Healing, and how does Zenkify incorporate it
                      into its services?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      {" "}
                      Theta healing is an efficient technique based on the
                      belief that our thoughts and beliefs significantly impact
                      our body. It is, therefore, used to let the brain enter a
                      meditative state to explore and transform already set
                      beliefs.
                    </p>
                    <p>
                      {" "}
                      Zenkify provides regular{" "}
                      <strong>Theta healing services in USA</strong>, and its
                      expert healers incorporate it into their holistic healing
                      services efficiently. They do so by identifying
                      client&apos;s negative beliefs via muscle testing and then
                      replacing them with positive ones.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <span>
                      Can Theta Therapy from Zenkify help with anxiety and
                      stress?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Yes, theta therapy helps cure various unwanted problems,
                      including anxiety, stress, manifestation, spiritual
                      growth, and emotional wellness.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <span>
                      What are the benefits of Theta Healing Services offered by
                      Zenkify?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      There are a lot of benefits of Theta healing services in
                      USA, including stress reduction, empowerment, emotional
                      healing, physical wellness, spiritual growth,
                      manifestation, and others.{" "}
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    <span>
                      How does Zenkify differentiate its Theta Therapy Services
                      from other modalities?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Zenkify&apos;s{" "}
                      <strong>theta therapy services in USA</strong> are quite
                      different from other healing sessions. This is because
                      while other healing processes try to relax the brain and
                      heal the entire body of physical or mental illness, theta
                      therapy focuses solely on studying the brain&apos;s
                      beliefs and transforming them positively.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    <span>
                      Are Theta Healing sessions with Zenkify suitable for
                      everyone?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Yes, theta healing therapy services in USA with Zenkify
                      are suitable for anyone dealing with energy-related issues
                      and seeking assistance for spiritual growth, amplifying
                      goal achievements, and other such aspects. Our sessions
                      can also be attended by babies, children, pregnant women,
                      and adults.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    <span>
                      What can I expect during a Theta Healing session with
                      Zenkify?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      A theta healing session with Zenkify includes various
                      phases. These include Theta Brainwave State Access, Belief
                      Restructuring, Energetic Healing and Intuition, Quantum
                      Connection and Manifestation. With the help of these
                      phases, our healers try to transform the thoughts of the
                      brain.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="6">
                  <Accordion.Header>
                    <span>
                      Is Theta Therapy at Zenkify effective for overcoming past
                      traumas?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Yes, the theta healing services in USA at Zenkify will
                      help you overcome past traumas by transforming your
                      thoughts. Our healers will try to eliminate the existing
                      negative thoughts from your brain and replace them with
                      positive ones.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="7">
                  <Accordion.Header>
                    <span>
                      Are there any scientific studies supporting the efficacy
                      of Zenkify&apos;s Theta Healing?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      No, <strong>theta healing services in USA</strong> lack
                      scientific support due to the subjective nature of the
                      healing experience. However, some studies have explored
                      the fantastic benefits of theta healing with complete
                      client satisfaction.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="8">
                  <Accordion.Header>
                    <span>
                      How long does it typically take to see results from Theta
                      Therapy with Zenkify?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Theta therapy in the USA works differently for different
                      people. While some people might see its results in a few
                      days only, for others, it may take more than 90 days to
                      show its effectiveness. This depends on the amount of
                      negative thoughts or healing an individual requires.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="9">
                  <Accordion.Header>
                    <span>
                      Can Theta Healing Services from Zenkify be done remotely?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Yes, you can remotely take Theta healing services in USA
                      from Zenkify. Just visit our website and book a session
                      with the healer of your choice at your preferred time.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                {next == false ? (
                  <div className="text-center ">
                    <Button
                      className="theme-btn text-align-center my-4"
                      onClick={() => setNext(true)}
                    >
                      View more
                    </Button>
                  </div>
                ) : (
                  <>
                    <Accordion.Item eventKey="10">
                      <Accordion.Header>
                        <span>
                          Are there any age restrictions for participating in
                          Theta Therapy with Zenkify?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          There are no age restrictions for participating in{" "}
                          <strong>theta therapy in the USA</strong> with
                          Zenkify.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="11">
                      <Accordion.Header>
                        <span>
                          What qualifications do practitioners at Zenkify have
                          in providing Theta Healing?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Practitioners at Zenkify Reiki offering Theta therapy
                          in USA are highly skilled, and experienced and have
                          been certified in an energy healing modality. This
                          ensures that our clients get the best solutions to
                          their problems and helps them get professional healing
                          treatment.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="12">
                      <Accordion.Header>
                        <span>
                          How often should I schedule Theta Therapy sessions
                          with Zenkify for optimal results?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Based on your needs, our expert healers at Zenkify can
                          suggest the best time to take{" "}
                          <strong>
                            theta healing therapy services in the USA
                          </strong>
                          . While some people may need it within a few days,
                          others may take it weekly or monthly.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="13">
                      <Accordion.Header>
                        <span>
                          Can Theta Healing from Zenkify be a complementary
                          therapy alongside traditional medicine?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Yes, <strong>Theta healing services in USA</strong>{" "}
                          can be used as a complementary therapy alongside
                          traditional medicine.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="14">
                      <Accordion.Header>
                        <span>
                          Are there any potential side effects or risks
                          associated with Theta Therapy at Zenkify?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          <strong>
                            Theta healing therapy services in the USA
                          </strong>{" "}
                          have a lot of advantages with only slight side
                          effects. These side effects include experiencing
                          intense feelings, disconcerting, or the emergence of
                          false memories.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="15">
                      <Accordion.Header>
                        <span>
                          What sets Zenkify&apos;s approach to Theta Healing
                          apart from other practitioners?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Zenkify Reiki stands apart from other providers due to
                          various reasons:
                        </p>
                        <p>
                          <strong>Customized Solutions:</strong> Zenkify Reiki
                          ensures to provide personalized solutions to every
                          customer based on their healing needs. Our healers
                          ensure to carefully examine every patient and come up
                          with emotional healing, stress relief, and physical
                          wellness solutions according to their needs.
                        </p>
                        <p>
                          <strong>Flexible Schedules:</strong> At Zenkify,
                          customers can choose their healing sessions according
                          to their comfort. We allow customers the flexibility
                          to choose schedules according to their timetable. This
                          ensures that they are more relaxed and comfortable
                          when attending the healing session.
                        </p>
                        <p>
                          <strong>Experienced Healers:</strong> Zenkify Reiki
                          ensures to provide you with the best treatment
                          possible. With our experienced and professional
                          healers, we are confident to provide solutions that
                          will undoubtedly help you get rid of your problems.
                        </p>
                        <p>
                          Hence, Zenkify Reiki ensures that we are not just
                          another healing service-providing company. Rather,
                          with our expertise, personalization, convenience, and
                          holistic principles, we are confident enough to stand
                          out from others.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="16">
                      <Accordion.Header>
                        <span>
                          Is Theta Therapy with Zenkify suitable for addressing
                          spiritual growth and development?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Undoubtedly,{" "}
                          <strong>Theta healing services in USA</strong> with
                          Zenkify are very effective in enhancing your spiritual
                          growth and development.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="17">
                      <Accordion.Header>
                        <span>
                          Can Theta Healing with Zenkify help with physical and
                          emotional ailments?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Yes,{" "}
                          <strong>theta therapy services in the USA</strong>{" "}
                          focus on contributing to various emotional blockages
                          that might be the reason behind physical problems. At
                          the same time, it also helps cure emotional ones with
                          effectiveness.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="18">
                      <Accordion.Header>
                        <span>
                          Are there any specific preparation steps I should take
                          before a theta-healing session with Zenkify?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          While our expert healers at Zenkify will assist you
                          entirely for the theta healing session, there are a
                          few prerequisites you can consider fulfilling. These
                          include staying hydrated throughout, being open and
                          responsive to your healer, and creating a comfortable
                          environment before the session.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="19">
                      <Accordion.Header>
                        <span>
                          How does Zenkify ensure client confidentiality and
                          privacy during Theta Therapy sessions?
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          No client data is shared without consent on Zenkify’s
                          website. Our healers also maintain complete privacy of
                          the client’s data during their therapy sessions.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                  </>
                )}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>
      {showSideButton && (
        <Link
          id="floatingBook"
          className="floating-book"
          aria-label="Book a FREE call now"
          href="/healers"
        >
          Book a FREE call now
        </Link>
      )}
    </>
  );
};

export default ThetaDetail;

ThetaDetail.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};
